import { computed } from "vue";
import { useStore } from "vuex";

export function useDarkMode() {
  const store = useStore();

  const isDarkTheme = computed(() => store.getters.isDarkTheme);

  const toggleDarkMode = () => {
    if (!document.startViewTransition) {
      store.commit("toggleDarkTheme");
      return;
    }

    document.startViewTransition(() => store.commit("toggleDarkTheme"));
  };

  const setDarkTheme = (isDark) => {
    store.commit("setDarkTheme", isDark);
  };

  return {
    isDarkTheme,
    toggleDarkMode,
    setDarkTheme,
  };
}
